// Oklahoma State University's undergraduate majors (#2652, round 2). Read
// on 2026-10-01 from the official 2026-2027 Catalog's Degree Programs page
// (catalog.okstate.edu/degree-programs), whose "Undergraduate Degree
// Requirements A-Z" list names every bachelor's program and option with its
// degree (BS, BA, BSAG, BSBA, BSET, ...); the college is the catalog's own
// section in each program's address. Options ("Agribusiness: Pre-Law,
// BSAG") are folded into their major; the American Chemical Society
// approved Chemistry BS is folded into Chemistry, BS. "Nursing: RN to BSN"
// (BS, for registered nurses) is kept by its catalog name beside Nursing,
// BSN. University Studies (BUS) is listed under the catalog's university-wide
// Degree Programs section. "Fire Protection and Safety Engineering
// Technology" is the catalog's own name (#2763). Left out: minors,
// certificates and graduate programs.
const majors = {
    "slug": "oklahoma-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Oklahoma State's official 2026-2027 Catalog, grouped by the college that offers it, with the degree it leads to. Options within a major, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Ferguson College of Agriculture",
            "source": {
                "label": "OSU 2026-2027 Catalog, Degree Programs",
                "url": "https://catalog.okstate.edu/degree-programs/"
            },
            "majors": [
                {
                    "name": "Agribusiness",
                    "degree": "BSAG"
                },
                {
                    "name": "Agricultural Communications",
                    "degree": "BSAG"
                },
                {
                    "name": "Agricultural Economics",
                    "degree": "BSAG"
                },
                {
                    "name": "Agricultural Education",
                    "degree": "BSAG"
                },
                {
                    "name": "Agricultural Leadership",
                    "degree": "BSAG"
                },
                {
                    "name": "Agricultural Systems Technology",
                    "degree": "BSAG"
                },
                {
                    "name": "Animal Science",
                    "degree": "BSAG"
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "BSAG"
                },
                {
                    "name": "Entomology",
                    "degree": "BSAG"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BSAG"
                },
                {
                    "name": "Food Science",
                    "degree": "BSAG"
                },
                {
                    "name": "Horticulture",
                    "degree": "BSAG"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                },
                {
                    "name": "Natural Resource Ecology & Management",
                    "degree": "BSAG"
                },
                {
                    "name": "Plant and Soil Sciences",
                    "degree": "BSAG"
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "OSU 2026-2027 Catalog, Degree Programs",
                "url": "https://catalog.okstate.edu/degree-programs/"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "BFA"
                },
                {
                    "name": "American Sign Language Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BS"
                },
                {
                    "name": "Applied Computer Programming",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Geoscience",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Geophysics",
                    "degree": "BS"
                },
                {
                    "name": "Geospatial Information Science",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Medicinal Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Multimedia Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Multimedia Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Music Education",
                    "degree": "BM"
                },
                {
                    "name": "Music Industry",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                },
                {
                    "name": "Musical Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physiology",
                    "degree": "BS"
                },
                {
                    "name": "Plant Biology",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Sports Media",
                    "degree": "BA"
                },
                {
                    "name": "Sports Media",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Strategic Communication",
                    "degree": "BA"
                },
                {
                    "name": "Strategic Communication",
                    "degree": "BS"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Zoology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education and Human Sciences",
            "source": {
                "label": "OSU 2026-2027 Catalog, Degree Programs",
                "url": "https://catalog.okstate.edu/degree-programs/"
            },
            "majors": [
                {
                    "name": "Aerospace Administration and Operations",
                    "degree": "BS"
                },
                {
                    "name": "Apparel Design and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Applied Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Early Child Care and Development",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "Fashion Merchandising",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BS"
                },
                {
                    "name": "Interior Design",
                    "degree": "BS"
                },
                {
                    "name": "Middle Level Education",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing: RN to BSN",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Recreation and Athletic Management",
                    "degree": "BS"
                },
                {
                    "name": "Recreational Therapy",
                    "degree": "BS"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering, Architecture and Technology",
            "source": {
                "label": "OSU 2026-2027 Catalog, Degree Programs",
                "url": "https://catalog.okstate.edu/degree-programs/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BSAE"
                },
                {
                    "name": "Architectural Design Studies",
                    "degree": "BS"
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "BEN"
                },
                {
                    "name": "Architecture",
                    "degree": "BAR"
                },
                {
                    "name": "Biosystems Engineering",
                    "degree": "BSBE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSCH"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCV"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSCP"
                },
                {
                    "name": "Construction Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Electrical Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEE"
                },
                {
                    "name": "Fire Protection and Safety Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Industrial Engineering and Management",
                    "degree": "BSIE"
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                },
                {
                    "name": "Mechatronics and Robotics",
                    "degree": "BS"
                },
                {
                    "name": "Mechatronics and Robotics",
                    "degree": "BSET"
                }
            ]
        },
        {
            "name": "Spears School of Business",
            "source": {
                "label": "OSU 2026-2027 Catalog, Degree Programs",
                "url": "https://catalog.okstate.edu/degree-programs/"
            },
            "majors": [
                {
                    "name": "Accounting Systems",
                    "degree": "BSBA"
                },
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Data Analytics",
                    "degree": "BSBA"
                },
                {
                    "name": "Economics",
                    "degree": "BSBA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "General Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Hospitality and Tourism Management",
                    "degree": "BSBA"
                },
                {
                    "name": "International Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BSBA"
                },
                {
                    "name": "Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Real Estate and Property Management",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "College of Professional Studies",
            "source": {
                "label": "OSU 2026-2027 Catalog, Degree Programs",
                "url": "https://catalog.okstate.edu/degree-programs/"
            },
            "majors": [
                {
                    "name": "Entertainment Media",
                    "degree": "BPS"
                },
                {
                    "name": "Health Care Administration",
                    "degree": "BPS"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "BPS"
                },
                {
                    "name": "Public Safety",
                    "degree": "BPS"
                }
            ]
        },
        {
            "name": "University-wide programs",
            "source": {
                "label": "OSU 2026-2027 Catalog, Degree Programs",
                "url": "https://catalog.okstate.edu/degree-programs/"
            },
            "majors": [
                {
                    "name": "University Studies",
                    "degree": "BUS"
                }
            ]
        }
    ]
};

export default majors;
